<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="420px">
      <v-card>
        <v-card-title class="blue darken-4 white--text">
          <v-toolbar-title>Đặt tổ hợp thi</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-6">
          <v-form v-bind="this.$attrs" ref="form">
            <div>Tổ hợp thi<span style="color: red">*</span></div>
            <v-select
              v-model="subjectGroup"
              :rules="[$rules.required]"
              dense
              outlined
              :items="subjectGroups"
              item-text="name"
              item-value="id"
            >
            </v-select>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-space-between pa-6">
          <v-btn color="blue darken-4" text @click="cancel" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" dark class="white--text elevation-0" @click="confirm">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { StudentExam } from '../../plugins/api'

export default {
  props: {
    exam: String,
    state: Boolean,
    subjectGroups: Array
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) {
        this.loading = false
      }
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      confirmDialog: false,
      subjectGroup: ''
    }
  },
  methods: {
    cancel() {
      this.$emit('closeDialog')
    },
    async confirm() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true
        const data = {
          exam: this.exam,
          subjectGroup: this.subjectGroup
        }
        const create = await StudentExam.assignSubjectGroupAll(data)
        if (create === 'finished') {
          this.$emit('refresh')
          this.cancel()
        } else {
          this.$alert.error('Lỗi tạo')
        }
        this.$loading.active = false
      }
    }
  }
}
</script>
